import { finalize, catchError, map } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { VacantRentalObject } from '../../model/vacant-rental-object';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { FormOfLease, RentalObjectCategory } from '../../model/const/enums';

@Injectable()
export class VacantRentalObjectService {
  constructor(
    private _client: HttpClient,
    private _messageService: MessageService,
    private _progressBar: ProgressBarService,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this._endPoint = config.apiEndpointV2 + '/vacant';
  }

  private _endPoint: string;

  public getByCategory({
    category,
    formOfLease,
  }: {
    category: RentalObjectCategory | string;
    formOfLease?: FormOfLease | string;
  }): Observable<VacantRentalObject[]> {
    this._progressBar.start();
    let params = new HttpParams();
    if (formOfLease !== undefined) {
      params = params.append('formoflease', formOfLease);
    }

    let path = `${this._endPoint}/category/${category}`;
    return this._client.get<VacantRentalObject[]>(path, { params: params }).pipe(
      map(items => items.map(item => Object.assign(new VacantRentalObject(), item))),
      catchError(error => {
        this._messageService.showError(error);
        return [];
      }),
      finalize(() => this._progressBar.stop())
    );
  }

  public getCooperativeHousing(): Observable<VacantRentalObject[]> {
    this._progressBar.start();
    let path = `${this._endPoint}/cooperative-housing`;
    return this._client.get<VacantRentalObject[]>(path).pipe(
      map(items => items.map(item => Object.assign(new VacantRentalObject(), item))),
      catchError(error => {
        this._messageService.showError(error);
        return [];
      }),
      finalize(() => this._progressBar.stop())
    );
  }

  getById(id: string): Observable<VacantRentalObject[]> {
    this._progressBar.start();
    return this._client.get(`${this._endPoint}/${id}`).pipe(
      map(data => Object.assign(new VacantRentalObject(), data)),
      catchError(error => {
        this._messageService.showError(error);
        return [];
      }),
      finalize(() => this._progressBar.stop())
    );
  }

  getByRentalObjectId(id: string): Observable<VacantRentalObject[]> {
    this._progressBar.start();
    return this._client.get(`${this._endPoint}/rental-object/${id}`).pipe(
      map(data => Object.assign(new VacantRentalObject(), data)),
      catchError(error => {
        this._messageService.showMessage('Hyresobjektet är inte ledigt. Det finns ett gällande hyreskontrakt på hyresobjektet.');
        return [];
      }),
      finalize(() => this._progressBar.stop())
    );
  }

  getOverview(category: RentalObjectCategory): Observable<VacantRentalObject[]> {
    this._progressBar.start();
    return this._client.get<any[]>(`${this._endPoint}/overview/category/${category}`).pipe(
      map(items => items.map(item => Object.assign(new VacantRentalObject(), item))),
      catchError(error => {
        this._messageService.showError(error);
        return [];
      }),
      finalize(() => this._progressBar.stop())
    );
  }
}
